import React from 'react';
import { connect } from 'react-redux';
import { setShowMap } from 'bundles/connect/components/store/actions/ui';

import { Button } from 'components/ui/button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faList, faLocationDot } from '@fortawesome/pro-solid-svg-icons';

type Props = {
  setShowMap: (showMap: boolean) => void;
  showMap: boolean;
}

export function MobileViewSwitcher({ setShowMap, showMap }: Props) {
  return (
    <div className="position-fixed bottom-0 pe-4 pb-5 d-block d-lg-none">
      <Button variant="ghost" onClick={() => setShowMap(!showMap)}>
        {showMap && (
          <span>
            <FontAwesomeIcon className="me-2" icon={faList} />
            List
          </span>
        )}
        {!showMap && (
          <span>
            <FontAwesomeIcon className="me-2" icon={faLocationDot} />
            Map
          </span>
        )}
      </Button>
    </div>
  );
}

const mapStateToProps = ({ ui }) => ({ showMap: ui.showMap });

export default connect(mapStateToProps, { setShowMap })(MobileViewSwitcher);
